import {UserOutlined} from "@ant-design/icons";
import React from "react";
import '../../assets/css/Dentobook.css';

interface UserIconProps {
    size: "large" | "medium" | "small" | "xs";
    className?: string;
    rounded?: boolean;
}

const UserIcon = ({size, className, rounded}: UserIconProps) => {

    let styles = {};

    switch (size) {
        case "large":
            styles = {fontSize: '60px', padding: '40px', borderRadius: rounded ? '200px' : ''};
            break;
        case "medium":
            styles = {fontSize: '40px', padding: '20px', borderRadius: rounded ? '200px' : ''};
            break;
        case "xs":
            styles = {fontSize: '20px', padding: '10px', borderRadius: rounded ? '200px' : ''};
            break;
        default:
            styles = {borderRadius: rounded ? '200px' : ''};
            break;
    }

    return (
        <UserOutlined className={"user-button " + className} style={styles} />
    );
};

export default UserIcon;